<script>
  import Blinker from "../blinker/Blinker.svelte";
</script>

<Blinker>404 - Found No Content for {document.location.href}</Blinker>
